import React, { useMemo } from 'react'
import { useTable } from 'react-table'

export const CommonTableContainer = ({ columns, data, status, noDataComponent, ...rest }) => {
    const tableColumns = useMemo(() => columns, [columns])
    const { getTableBodyProps, getTableProps, headerGroups, prepareRow, rows } = useTable({ columns: tableColumns, data })
    return (
        <table className="table table-bordered" {...getTableProps()} {...rest}>
            <thead>
                {headerGroups.map((headerGroup) => {
                    return (
                        <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()} >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    key={index}
                                    className={`t-col-${index + 1} ${column.className}`}
                                    {...column.getHeaderProps()}
                                >
                                    {column.render("Header")}
                                    {column.isInfoIcon ? (
                                        <a
                                            onClick={() => {
                                                // setNameModal(true)
                                                // setTitle(column.Header)
                                            }}
                                        >
                                            <i
                                                title="info"
                                                className="bx bx-info-circle ms-1 info-icon"
                                            ></i>
                                        </a>
                                    ) : null}
                                </th>
                            ))}
                        </tr>
                    )
                }
                )}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                    prepareRow(row)
                    return (
                        <tr key={row.id} {...row.getRowProps()}
                            className={`row-hover ${status == true && (row?.original?.status == "4") ? "bg-light-success" : ''}`}
                        >
                            {row.cells.map((cell) => {
                                const { className, style } = cell.column
                                return (
                                    <td key={cell.id} {...cell.getCellProps({ className, style })}>
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}

                {data.length == 0 ? (
                    <td
                        colSpan="10"
                        className="text-center"
                        style={{ padding: "10px", border: "none" }}
                    >
                        No Data Available
                    </td>
                ) : null}
            </tbody>
        </table>
    )
}
